import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Button, Form, Modal } from "react-bootstrap";
import Resizer from "react-image-file-resizer";
import { apiUrl, myFetchPost, getMobileOperatingSystem, getCookie } from "../utility";
import { db } from "../utility/firebase";
import {
  collection,
  doc,
  addDoc,
  setDoc,
  getDoc,
  serverTimestamp,
  increment,
} from "firebase/firestore";
import "../css/MessageInput.css";

const MessageInput = (props) => {
  const {
    prefillText,
    currentUser,
    chatUserData,
    currentChatRoomId,
    setIsSendingMessage,
    setUploadPercentage,
    itemId,
    itemData,
    chatRoomMeta,
  } = props;

  /* message input */
  const [text, setText] = useState("");

  /* dialog */
  const [dialogMessage, setDialogMessage] = useState("");
  const [showDialog, setShowDialog] = useState(false);
  const [createMessageError, setCreateMessageError] = useState("");
  const [showCreateMessageErrorDialog, setShowCreateMessageErrorDialog] = useState(false);

  /* cookie */
  const [deviceId, setDeviceId] = useState("");

  useEffect(() => {
    const cookieValue = getCookie("dcff_psid");
    if (cookieValue) {
      setDeviceId(cookieValue);
    }
  }, []);

  useEffect(() => {
    if (text != prefillText) {
      setText(prefillText);
    }
  }, [prefillText]);

  useEffect(() => {
    setText('');
  }, [currentChatRoomId]);

  const navigate = useNavigate();

  const fileChangedHandler = async (event) => {
    const maxFiles = 10;
    const selectedFiles = Array.from(event.target.files);
    const files = selectedFiles.slice(0, maxFiles);

    if (selectedFiles.length >= maxFiles) {
      alert('一次最多傳送 ' + maxFiles + ' 張圖片');
    }

    setIsSendingMessage(true);

    const resizedImgPromises = files.map((file) =>
      new Promise((resolve) => {
        Resizer.imageFileResizer(
          file,
          1200, // desired width
          1200, // desired height
          'JPEG', // format
          85, // quality
          0, // rotation
          (uri) => {
            resolve(uri);
          },
          "file",
          200,
          200
        );
      })
    );

    Promise.all(resizedImgPromises).then((resizedImgs) => {
      return resizedImgs;
    }).then(async (resizedImages) => {
      try {
        await handleSendImages(resizedImages);
      } catch (error) {
      }
      /*
      for (let i = 0; i < resizedImages.length; i++) {
        const file = resizedImages[i];
        try {
          await handleSendImage(file);
        } catch (error) {
        }
      }
      */
    });

    /*
    var fileInput = false;
    if (event.target.files[0]) {
      fileInput = true;
    }
    if (fileInput) {
      try {
        Resizer.imageFileResizer(
          event.target.files[0],
          1200,
          1200,
          "JPEG",
          85,
          0,
          (uri) => {
            // setImage(uri);
            // image is not set before calling handleSendMessage(), so this is not working
            handleSendImage(uri);
          },
          "file",
          200,
          200
        );
      } catch (err) { }
    }
    */
  };

  const handleSendMessage = async (e) => {
    if (e) e.preventDefault();

    try {
      setIsSendingMessage(true);
      const token = await currentUser.getIdToken();
      if (text != "") {
        let workingChatRoomId = currentChatRoomId;
        let targetUserId = chatUserData.uid;

        /* if we got itemId, we need to create the chatRoom first */
        if (itemId) {
          const requestData = {
            itemID: itemId,
            platform: getMobileOperatingSystem(),
            deviceId: deviceId,
          };
          const res = await myFetchPost(
            `${apiUrl}/chat/createroom`,
            requestData,
            {
              Authorization: "Bearer " + token,
            }
          );
          if (res.result == "failed") {
            if (res.message) {
              throw new Error(res.message);
            }
            throw new Error("未能開始對話");
          }
          workingChatRoomId = res.chatRoomId;
          targetUserId = res.targetUserId.toString();
        }
        await createMessage(token, workingChatRoomId, "", itemId, targetUserId);
        setText("");
        setIsSendingMessage(false);
      }
    } catch (error) {
      setIsSendingMessage(false);
      setDialogMessage(error.message);
      setShowDialog(true);
    }
  };

  const handleSendImages = async (images) => {
    try {
      const token = await currentUser.getIdToken();
      setIsSendingMessage(true);

      let workingChatRoomId = currentChatRoomId;
      let targetUserId = chatUserData.uid;

      for (let i = 0; i < images.length; i++) {
        const image = images[i];
        let percent = 0;
        let formData = new FormData();
        formData.append("chat_room_id", workingChatRoomId);
        formData.append("item_id", itemData.itemId);
        formData.append("target_user_id", targetUserId);
        formData.append("file", image);

        const config = {
          onUploadProgress: (progressEvent) => {
            const { loaded, total } = progressEvent;
            percent = Math.floor((loaded * 100) / total);
            if (percent <= 100) {
              setUploadPercentage(percent);
            }
          },
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "multipart/form-data",
          },
        };

        /* let axios do the work */
        const res = await axios.post(`${apiUrl}/upload`, formData, config);
        const file = {
          url: res.data.url,
          width: res.data.width,
          height: res.data.height,
        };
        await createMessage(token, workingChatRoomId, file, itemId, targetUserId);
      }

      setText("");
      setIsSendingMessage(false);
      setUploadPercentage(0);
    } catch (error) {
      setIsSendingMessage(false);
      setUploadPercentage(0);
      setDialogMessage(error.message);
      setShowDialog(true);
    }
  }

  const createMessage = async (
    token,
    chatRoomId,
    file = {},
    itemId,
    targetUserId
  ) => {
    const requestData = {
      chatRoomId: chatRoomId,
      text: text,
      file: file,
      itemId: itemId,
      targetUserId: targetUserId,
    };

    try {
      /* update the chatRoom/lastMessage, this needs to be run before addDoc so the unread counter works */
      const newDocRef = doc(db, "chatRooms", chatRoomId);

      const docSnap = await getDoc(newDocRef);

      if (docSnap.exists()) {
        const chatRoomData = docSnap.data();
        if (!JSON.stringify(chatRoomData.activeMembers).includes(targetUserId)) {
          throw new Error("chat_target_removed")
        } else if (!JSON.stringify(chatRoomData.activeMembers).includes(currentUser.uid)) {
          throw new Error("chat_me_removed")
        }
      }

      await setDoc(
        newDocRef,
        {
          lastUpdatedTime: serverTimestamp(),
          lastMessage: {
            sentBy: currentUser.uid,
            sentTo: targetUserId,
            messageText: text.trim() ? text.trim() : "{file}",
            messageTime: serverTimestamp(),
            unReadCount:
              increment(1) /* only works when referring to it directly */,
          },
        },
        { merge: true }
      );

      /* save the message */
      const addMessageDoc = async () => {
        /* add new message */
        const postData = {
          createdTime: serverTimestamp(),
          createdUser: currentUser.uid,
          type: "msg",
          text: text.trim(),
          file: file,
          offeredTime: null,
          offeredPrice: null,
          isRead: false,
          readTime: null,
          isNotified: false,
        };

        //const newDocRef = doc(db, "chatRooms", chatRoomId, "messages");
        const docRef = await addDoc(
          collection(db, "chatRooms", chatRoomId, "messages"),
          postData
        );

        return docRef.id;
        //await db.collection("chatRooms").doc(chatRoomId).collection("messages").add(postData);
      };

      const newMessageId = await addMessageDoc();

      const requestData = {
        chatRoomId: chatRoomId,
        messageId: newMessageId,
        platform: getMobileOperatingSystem(),
        deviceId: deviceId,
      };
      
      const res = myFetchPost(`${apiUrl}/chat/handleaddmessage`, requestData, {
        Authorization: "Bearer " + token,
      });

      if (res.result == "failed") {
        //throw new Error(res.message);
      }

      /* if we are in create chat mode, we replace the url */
      if (itemId) {
        navigate(`/${chatRoomId}`, { replace: true });
      }
    } catch (error) {
      if (error.message == 'chat_target_removed') {
        setCreateMessageError("對方已刪除了此對話, 因此未能傳送訊息。");
        setShowCreateMessageErrorDialog(true);
      } else if (error.message == 'chat_me_removed') {
        setCreateMessageError("未能傳送訊息! 訊息已被刪除。");
        setShowCreateMessageErrorDialog(true);
      } else {
        setCreateMessageError("未能傳送訊息! 對話雙方可能選擇不接收相關的訊息。");
        setShowCreateMessageErrorDialog(true);
      }
    }
  };

  const allowUploadPhotos = parseInt(itemId) > 0 ? false : true;

  return (
    <div className="composeMessageWrap">
      <Form onSubmit={(e) => { handleSendMessage(e); e.target.querySelector('.messageInputBox').style.height = "auto"; }} className="composeMessageForm">
        <label className="photoUploadBtn" htmlFor="img" style={allowUploadPhotos ? {} : { color: '#ccc' }}>
          <i className="bi bi-camera"></i>
        </label>
        {
          allowUploadPhotos ? <input
            multiple
            onChange={fileChangedHandler}
            type="file"
            id="img"
            accept="image/*"
            style={{ display: "none" }}
            disabled={chatRoomMeta?.require_verification ? true : false}
          /> : <input
            onChange={fileChangedHandler}
            type="file"
            id="img"
            accept="image/*"
            style={{ display: "none" }}
            disabled
          />
        }
        <div className="messageInput">
          <Form.Control
            as="textarea" rows={1}
            placeholder="輸入訊息"
            value={text}
            onChange={(e) => { setText(e.target.value.slice(0, 5000)) }}
            className="messageInputBox"
            onInput={(e) => {
              e.target.style.height = "auto";
              e.target.style.height = (e.target.scrollHeight + 2) + "px";
            }}
            disabled={chatRoomMeta?.require_verification ? true : false}
          />
        </div>
        <Button
          type="submit"
          disabled={text.trim().length == 0}
          className="sendMessageBtn"
        >
          <i className="bi bi-send"></i>{" "}
          <span className="d-none d-sm-inline">傳送</span>
        </Button>
      </Form>
      {/* system message dialog */}
      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showCreateMessageErrorDialog}
        onHide={() => {
          setShowCreateMessageErrorDialog(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>系統訊息</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {createMessageError}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowCreateMessageErrorDialog(false);
            }}
          >
            關閉
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showDialog}
        onHide={() => {
          setShowDialog(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>系統訊息</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {dialogMessage}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowDialog(false);
            }}
          >
            關閉
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default MessageInput;
